import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { Header } from "@tanstack/react-table";
import { ColumnHeaderLabel } from "./ColumnHeaderLabel";
import { SortDropdownWrapper } from "./SortDropdownWrapper";
import { ListLayoutProps } from "@/types/list";

export const Cell = <TData,>({ header, layout }: { header: Header<TData, unknown>; layout: ListLayoutProps }) => {
	if (header.isPlaceholder) return null;

	const column = header.column;
	const isLeaf = !header.subHeaders?.length;
	const columnDef = column?.columnDef;
	const meta = columnDef?.meta ?? {};

	const resolvedHeader =
		typeof header.column?.columnDef?.header === "function"
			? header.column.columnDef.header(header.getContext())
			: (header.column?.columnDef?.header ?? header.id);

	const unit = meta.unit;
	const sortableHeaderClass = meta.sortableHeaderClass || "";
	const headerClassName = meta.headerClassName || "";
	const headerLabelClass = meta.headerLabelClass || "";
	const headerLabelUnitClass = meta.headerLabelUnitClass || "";
	const renderFilter = meta.renderFilter;

	const isSortable = column?.getCanSort?.();
	// const isSorted = column?.getIsSorted?.();
	const spaceingClass = "px-2 py-2 ";
	const sortablepadding = isSortable ? "" : spaceingClass;
	const cellClass = sortablepadding + "flex items-center  leading-tight gap-2 " + sortableHeaderClass;
	if (isLeaf) {
		return (
			<TableHead key={header.id} colSpan={header.colSpan} className={cn(" px-1 ", headerClassName)}>
				<div className={cellClass}>
					{isSortable ? (
						<SortDropdownWrapper
							column={column}
							className={spaceingClass}
							disabled={layout?.loading || false}
						>
							<ColumnHeaderLabel
								label={resolvedHeader}
								unit={unit}
								headerLabelClass={headerLabelClass}
								headerLabelUnitClass={headerLabelUnitClass}
							/>
						</SortDropdownWrapper>
					) : (
						<ColumnHeaderLabel
							label={resolvedHeader}
							unit={unit}
							headerLabelClass={headerLabelClass}
							headerLabelUnitClass={headerLabelUnitClass}
						/>
					)}
					{renderFilter && (
						<div className="flex items-center justify-center gap-1">{renderFilter({ column })}</div>
					)}
				</div>
			</TableHead>
		);
	}

	return (
		<TableHead key={header.id} colSpan={header.colSpan} className={cn("h-5", headerClassName)}>
			<div className="text-center text-[0.6rem] font-light uppercase text-stale-400">{resolvedHeader}</div>
		</TableHead>
	);
};
